export const CHEATSHEET_MESSAGES = {
    cheatsheet: "تقلب‌نامه",
    cheatsheetOf: (title: string) => `تقلب‌نامه‌ی ${title}`,
    seoDescription: "تقلب‌نامه‌های دوره",
    loading: "در حال بارگذاری...",
    listFailed: "دریافت تقلب‌نامه‌ها با مشکل مواجه شد.",
    listEmpty: "هنوز تقلب‌نامه‌ای برای این دوره وجود ندارد.",
    failed: "دریافت تقلب‌نامه با مشکل مواجه شد.",
    notFound: "تقلب‌نامه پیدا نشد.",
    noContent: "این تقلب‌نامه هنوز محتوایی ندارد."
};